import { IManufacturingProcess } from '@/src/interfaces/generated/contentful';
import { Box } from '@/src/packages/components/ui/Box';
import { Carousel } from '@/src/packages/components/ui/Carousel';
import { Heading } from '@/src/packages/components/ui/Heading';
import { PageSection } from '@/src/packages/components/ui/PageSection';
import { PageSectionSubheading } from '@/src/packages/components/ui/PageSection/PageSectionSubheading';
import { PageSectionTitle } from '@/src/packages/components/ui/PageSection/PageSectionTitle';
import { VideoManufacturing } from '@/src/packages/components/ui/Video';
import Image from 'next/image';
import { SwiperSlide } from 'swiper/react';

export const ProductManufacturingProcess = ({
  manufacturingProcess,
}: {
  manufacturingProcess: IManufacturingProcess;
}) => {
  return (
    <PageSection>
      <PageSectionTitle>Making</PageSectionTitle>
      <PageSectionSubheading>
        {manufacturingProcess.fields.description}
      </PageSectionSubheading>
      <Box className="-mx-gutter mb-0.5 lg:mx-0">
        <VideoManufacturing />
      </Box>
      <Carousel slidesPerView={1.2} isFlush>
        {manufacturingProcess &&
          manufacturingProcess.fields.steps &&
          manufacturingProcess.fields.steps.map((item) => {
            const image = item?.fields?.images && item.fields.images[0];

            return (
              <SwiperSlide key={item.sys.id}>
                <Box className="relative aspect-[3/4] lg:aspect-video">
                  {image && (
                    <Image
                      src={image.fields.file.url}
                      alt=""
                      fill
                      className="object-cover"
                    />
                  )}
                </Box>

                <Box className="flex w-full flex-col space-y-1 p-4">
                  <Heading as="h3" fontWeight="medium">
                    {item.fields.name}
                  </Heading>
                  <Box className="opacity-75">{item.fields.description}</Box>
                </Box>
              </SwiperSlide>
            );
          })}
      </Carousel>
    </PageSection>
  );
};
